import { format, processNamespace, text } from '@opengov/locale/namespaces';

export type LocaleText = typeof report;

export const report = {
  apply: text(),
  cancel: text(),
  save: text(),
  description: text(),
  welcome: text(),
  welcomeDescription: text(),
  looksLikeYouDontHaveAny: text(),
  looksLikeAdminHasntMade: text(),
  createNewReport: text(),
  object: text(),
  loadingDatasets: text(),
  loading: text(),
  create: {
    title: text(),
    datasetUnavailable: text(),
    selectAnotherDataset: text(),
    reportCreationFailure: text(),
    somethingWentWrong: text(),
    titleAndDescriptionStepLabel: text(),
    datasetStepLabel: text(),
    reportTypeStepLabel: text(),
    typeStepTitle: text(),
    typeStepDescription: text(),
    customCategory: text(),
    accountsSummaryReport: text(),
    chartAndDetailsReport: text(),
    accountsSummaryDescription: text(),
    chartAndDetailsDescription: text(),
    titleAndDescriptionStepTitle: text(),
    titleAndDescriptionStepTitleInputLabel: text(),
    titleAndDescriptionStepTitleInputError: text(),
    titleAndDescriptionStepDescriptionInputLabel: text(),
    titleAndDescriptionStepDescription: text(),
    datasetStepTitle: text(),
    datasetStepDescription: text(),
    datasetStepSubDescription: text(),
    datasetStepLink: text(),
    datasetsLoading: text(),
    cancelButton: text(),
    next: text(),
    back: text(),
    finish: text(),
    modal: {
      title: text()
    },
    lastUpdated: text(),
    date: format<{ date: Date }>()
  },
  name: text(),
  query: {
    failure: {
      headerText: text(),
      bodyText: text(),
      cyclicalCalculationHeaderText: text(),
      cyclicalCalculationBodyText: text()
    },
    summaryTooMuchData: {
      headerText: text(),
      bodyText: text()
    },
    visualizationTruncated: {
      headerText: text(),
      bodyText: text()
    }
  },
  timePeriod: text(),
  navigation: {
    headerTitle: text(),
    reportingApp: text(),
    reportApp: text(),
    dashboardsApp: text()
  },
  delete: {
    label: text(),
    warning: text(),
    confirmString: text()
  },
  loadingReports: text(),
  selectListView: text(),
  reportTable: {
    groupByFilterControlsDisabled: text(),
    groupedSubtotalsText: text(),
    recordsText: text(),
    recordsDescriptionText: text(),
    showTotals: text(),
    coaAscending: text(),
    coaDescending: text(),
    code: text(),
    codes: text(),
    calculated: text(),
    emptyValues: text(),
    dateFormat: format<{ date: Date }>(),
    usdFormat: format<{ value: number }>(),
    percentFormat: format<{ value: number }>(),
    numberFormat: format<{ value: number }>(),
    periodFormat: format<{ value: number }>(),
    title: text(),
    dataset: text(),
    datasetUpdated: text(),
    createdBy: text(),
    lastUpdated: text(),
    updatedBy: text(),
    datasetNotFound: text(),
    onDate: format<{ date: Date }>(),
    visibility: text(),
    sort: text(),
    apply: text(),
    clear: text(),
    filter: text(),
    filterTo: format<{ value: string }>(),
    aToZ: text(),
    zToA: text(),
    moreThan: text(),
    lessThan: text(),
    minMaxError: text(),
    startDate: text(),
    endDate: text(),
    dateError: text(),
    groupByColumn: format<{ column: string }>(),
    groupByNone: text(),
    groupByTargetStatus: text(),
    groupByNoneTooltip: text(),
    groupByTargetStatusTooltip: text(),
    clickToFilterDate: {
      before: format<{ date: string }>(),
      on: format<{ date: string }>(),
      after: format<{ date: string }>()
    },
    clickToFilterNumber: {
      less: format<{ value: string }>(),
      equal: format<{ value: string }>(),
      greater: format<{ value: string }>()
    },
    filterErrorToast: {
      header: text(),
      body: text()
    },
    columnEdit: {
      settings: text(),
      title: text(),
      naming: text(),
      namingError: text(),
      tooManyUniqueValues: text(),
      displayName: text(),
      defaultName: text(),
      display: text(),
      availableMenus: text(),
      showMenu: text(),
      organize: text(),
      categorize: text(),
      calcHeader: text(),
      condHeader: text(),
      conditionalOneFactor: format<{
        column: string;
        condition: string;
        value: string;
        ifCase: string;
        elseCase: string;
      }>(),
      conditionalBetween: format<{
        column: string;
        value1: string;
        value2: string;
        ifCase: string;
        elseCase: string;
      }>(),
      readableCondition: {
        greaterThan: text(),
        greaterThanOrEqualTo: text(),
        lessThan: text(),
        lessThanOrEqualTo: text(),
        equalTo: text(),
        notEqualTo: text()
      }
    },
    columnManage: {
      addColumnHeader: text(),
      addColumnDescription: text(),
      showAll: text(),
      hideAll: text(),
      of: text(),
      visible: text(),
      pinnedLeft: text(),
      pinnedRight: text(),
      columnsMatch: text(),
      groupByTooltip: text(),
      inputPlaceholder: text()
    },
    allColumns: text(),
    searchContextMenuQuery: format<{ query: string; columnName: string }>(),
    data: text(),
    export: text(),
    exportGroupByMustBeEnabled: text(),
    exportSubtotals: text(),
    clickForMoreActions: text(),
    cellErrors: {
      zeroDivisionCellText: text(),
      zeroDivisionTooltipText: text(),
      zeroDivisionFilterText: text(),
      unexpectedValueCellText: text(),
      unexpectedValueTooltipText: text(),
      unexpectedValueFilterText: text(),
      invalidDateCellText: text(),
      invalidDateTooltipText: text(),
      invalidDateFilterText: text(),
      limitedDecimalValueTooltipText: text(),
      valueFilterLessThan: text(),
      valueFilterEqualTo: text(),
      valueFilterGreaterThan: text()
    },
    tabs: {
      summary: text(),
      details: text()
    },
    publicDetailTableExport: {
      exportInProgress: text(),
      exportDurationTruncationWarning: text(),
      exportDurationWarning: text(),
      exportFailed: text(),
      exportFailedMessage: text()
    }
  },
  selectCardView: text(),
  newReport: text(),
  plainNumber: format<{ count: number }>(),
  chartNotAvailable: text(),
  calendarUnits: {
    day: text(),
    fiscalPeriod: text(),
    fiscalQuarter: text(),
    fiscalYear: text(),
    month: text(),
    quarter: text(),
    week: text(),
    year: text()
  },
  calendarUnitsSingular: {
    day: text(),
    fiscalPeriod: text(),
    fiscalQuarter: text(),
    fiscalYear: text(),
    month: text(),
    quarter: text(),
    week: text(),
    year: text()
  },
  legend: {
    sortOrderAsc: text(),
    sortOrderDesc: text(),
    sortOrderAz: text(),
    sortOrderZa: text()
  },
  reportExplorer: {
    controls: {
      amount: text(),
      aggregate: text(),
      accountString: text(),
      accountType: text(),
      by: text(),
      categorizedBy: text(),
      count: text(),
      createView: text(),
      data: text(),
      date: text(),
      legendAndRows: text(),
      show: text(),
      rows: text(),
      actuals: text(),
      columns: text(),
      columnGroup: text(),
      text: text(),
      undo: text(),
      viewPlaceholder: text(),
      noSavedViews: text(),
      viewEditor: text(),
      viewPrefix: text(),
      viewDescriptionHeader: text(),
      modified: text(),
      filters: text(),
      showAs: text(),
      value: text(),
      percent: text(),
      controlsErrorToast: {
        header: text(),
        body: text()
      },
      targetStatus: text(),
      segment: text(),
      columnGroupDisabledToolTipText: text(),
      sortLegends: text(),
      sort: text(),
      barChart: text()
    },
    data: {
      loading: text(),
      noResults: text(),
      noResultsDescription: text()
    },
    filters: {
      clear: text(),
      header: text(),
      headerDescription: text(),
      noFilters: text(),
      none: text(),
      equal: text(),
      inSet: text(),
      greaterThanOrEqual: text(),
      lessThanOrEqual: text(),
      notEqual: text(),
      contains: text(),
      doesNotContain: text(),
      isBlank: text(),
      isNotBlank: text(),
      beginsWith: text(),
      and: text(),
      or: text(),
      pillBlank: text(),
      pillNotBlank: text(),
      columnSearchErrorToast: {
        header: text(),
        body: format<{ searchString }>()
      }
    },
    delete: {
      body1: text(),
      body2: text(),
      confirmationLabel: format<{ confirm: string }>(),
      helper: format<{ confirm: string }>(),
      failedBody: text(),
      failedHeader: text(),
      suceededMessage: text(),
      title: text(),
      rowGroup: {
        title: text(),
        body: text(),
        isLastOneText: text(),
        selectedRowGroupDependantDescription: format<{ selectedRowGroupName: string }>(),
        warning: text()
      }
    },
    menu: {
      visualization: text(),
      loadingVisualization: text(),
      updatingVisualization: text(),
      loadingDataTable: text(),
      updatingDataTable: text(),
      table: text(),
      barChart: text(),
      lineChart: text(),
      stackedChart: text(),
      areaChart: text(),
      pieChart: text(),
      categoriesHidden: text(),
      legendPrompt: text()
    },
    validators: {
      rangeWithWildcard: text(),
      rangeWithoutBounds: text(),
      unclosedQuote: text(),
      underscoreCharacter: text(),
      percentCharacter: text(),
      unnecessaryCommas: text(),
      multipleErrors: text()
    },
    accountCodeFilters: {
      label: text(),
      guide: text(),
      learnMore: text(),
      globalFilters: text(),
      globalSubtitle: text(),
      columnSettings: text(),
      columnDescription: text(),
      columnSubtitle: format<{ grouping: string }>(),
      columnBreakdown: format<{ showing: string; grouping: string }>(),
      controlBlockBreakDown: format<{ selectedAccountType: string; selectedRowGrouping: string }>(),
      none: text(),
      noMatch: text()
    },
    emptyValues: text(),
    notApplicable: text()
  },
  reportSavedViews: {
    editViewDetails: text(),
    saveAsNewView: text(),
    updateView: text(),
    deleteView: text(),
    listLabel: text(),
    loadingIndicator: text(),
    openInExplorerButton: text(),
    editButton: text(),
    preview: text(),
    previewCreated: text(),
    previewData: text(),
    updatingLive: text(),
    welcomeMessage: {
      header: text(),
      description: text(),
      secondaryDescription: text(),
      openExplorerButton: text()
    }
  },
  report: {
    poweredBy: text(),
    createBreadcrumb: text(),
    reportsBreadcrumb: text(),
    folderParentsBreadcrumb: text(),
    dataUpdated: text(),
    lastSubmission: text(),
    dataUpdatedDate: format<{ date: Date }>(),
    explorerTab: text(),
    viewsTab: text(),
    settingsTab: text(),
    edit: text(),
    export: text(),
    exportAsPDF: text(),
    exportAsCSV: text(),
    duplicate: text(),
    delete: text(),
    copy: text(),
    moreActions: text(),
    settings: {
      settings: text(),
      about: text(),
      edit: text(),
      email: text(),
      name: text(),
      reportTitle: text(),
      reportDescription: text(),
      reportData: text(),
      reportDetails: text(),
      reportVisibility: text(),
      publicLink: text(),
      cancel: text(),
      save: text(),
      toastFailHeader: text(),
      toastFailBody: text(),
      toastVisibilitySuccessHeader: text(),
      toastVisibilitySuccessBody: text(),
      toastVisibilityFailHeader: text(),
      toastVisibilityFailBody: text(),
      templatizeReport: text(),
      templatizeReportDisabledExplanation: text(),
      templatizeReportUsingExtendedColumns: text(),
      templatizeReportUsingExtendedColumnsHeader: text(),
      templatizeSettings: text(),
      datasetUpdatedDate: format<{ date: Date }>(),
      toastDatasetUpdatedSuccessHeader: text(),
      toastDatasetUpdatedSuccessBody: text(),
      toastDatasetUpdatedFailHeader: text(),
      toastDatasetUpdatedFailBody: text(),
      backButton: text(),
      returnToReportDetails: text()
    },
    updateView: text()
  },
  templatePromptReport: {
    formTitle: text(),
    prompts: {
      lensTitle: text(),
      lens: text()
    }
  },
  reportData: {
    cancel: text(),
    apply: text(),
    edit: text(),
    datasetName: text(),
    modalTitle: text(),
    modalDescription: text(),
    filterPlaceholder: text(),
    cardTitle: text(),
    columnHeadingDataset: text(),
    columnHeadingLastUpdated: text(),
    datasetsAriaLabel: text(),
    formAriaLabel: text(),
    dataManagerLinkAriaLabel: text(),
    datasetUpdatedDate: format<{ date: Date }>(),
    noMatches: text(),
    uploadNewDataset: text(),
    toastDatasetUpdatedSuccessHeader: text(),
    toastDatasetUpdatedSuccessBody: text(),
    toastDatasetUpdatedFailHeader: text(),
    toastDatasetUpdatedFailBody: text(),
    loadingText: text(),
    loadingError: text(),
    checkingColumnsText: text(),
    applyingDatasetText: text(),
    tryAgain: text(),
    invalidDatasetWarningTitle: text(),
    invalidDatasetWarningBody: text(),
    incompatibleDatasetWarningTitle: text(),
    incompatibleDatasetWarningBody: text(),
    reviewIntro: text(),
    reviewTargetColumnHeading: text(),
    reviewRemoveLabel: text(),
    reviewRemovalSummaryHeading: text(),
    reviewAutoRemovedHeading: text(),
    reviewCoaRebindHeading: text(),
    reviewCoaRebindBody: text(),
    reviewSegmentRemapping: format<{ label: string; from: string; to: string }>(),
    reviewUnanalysableHeading: text(),
    reviewFilterValuesWarning: text(),
    reviewContinue: text(),
    reviewBack: text(),
    duplicateColumnsWarningTitle: text(),
    duplicateColumnsWarningBody: format<{ columns: string }>(),
    reviewOutstandingHint: format<{ columns: string }>(),
    reviewTargetTakenBy: format<{ column: string }>(),
    reviewCollisionHeading: format<{ target: string }>(),
    reviewCollisionBody: text(),
    coaRefusedWarningTitle: text(),
    coaRefusedWarningBody: text(),
    reviewUsageKinds: {
      filter: text(),
      calculation: text(),
      visualization: text(),
      detailsColumn: text(),
      sort: text(),
      grouping: text(),
      presentation: text(),
      delegate: text()
    }
  },
  manageAccess: {
    access: text(),
    add: text(),
    addUsers: text(),
    cancel: text(),
    changesMade: text(),
    edit: text(),
    editor: text(),
    email: text(),
    emptySearch: text(),
    manageAccess: text(),
    name: text(),
    noAccess: text(),
    notFound: text(),
    owner: text(),
    remove: text(),
    save: text(),
    usersAndGroups: text(),
    viewer: text(),
    savedViewEditor: text()
  },
  unavailable: {
    reportsGallery: text(),
    reportUnavailable: text(),
    reportUnavailableDescription: text()
  },
  calculations: {
    createCalculationModal: {
      createNewColumn: text(),
      calculate: text(),
      calculateDescription: text(),
      conditional: text(),
      conditionalDescription: text()
    },
    deleteCalculationModal: {
      cancelButtonText: text(),
      categorizeMenu: text(),
      conditionalColumnType: text(),
      deleteButtonText: text(),
      deleteColumnConfirmBody: text(),
      deleteColumnConfirmHeader: text(),
      deleteCreatedColumnFailureToastBody: text(),
      deleteCreatedColumnFailureToastHeader: text(),
      deleteCreatedColumnSucessToastHeader: text(),
      filter: text(),
      infixColumnType: text(),
      isBeingUsedInTheFollowing: text(),
      nonDeleteableHeader: text(),
      organizeMenu: text(),
      showMenu: text(),
      toDeleteThisColumnRemoveItFromTheAbove: text()
    },
    basicCalculationModal: {
      calculateNewColumn: text(),
      columnName: text(),
      value1: text(),
      value2: text(),
      operation: text(),
      newColumnName: text(),
      returnToStart: text(),
      preview: text(),
      previewMessage: text(),
      selectValue: text(),
      customValueNumeric: text(),
      customValuePercentage: text(),
      customValueDateYear: text(),
      customValueDateMonth: text(),
      customValueDateDay: text(),
      plusOperator: text(),
      minusOperator: text(),
      multipliedByOperator: text(),
      dividedByOperator: text(),
      create: text(),
      loadingPreview: text(),
      createColumnSuccessToastHeader: text(),
      createColumnSuccessToastMessage: text(),
      createColumnFailureToastHeader: text(),
      createColumnFailureToastMessage: text()
    },
    conditionalModal: {
      createNewColumn: text(),
      backButtonText: text(),
      nextButtonText: text(),
      submitButtonText: text(),
      step1Title: text(),
      step2Title: text(),
      step2SelectPlaceholder: text(),
      step3ATitle: text(),
      step3SelectConditionPlaceholder: text(),
      step3SelectValuePlaceholder: text(),
      step3BTitle: text(),
      step4Title: text(),
      textColumn: text(),
      textColumnDescription: text(),
      textColumnExamples: text(),
      numberColumn: text(),
      numberColumnDescription: text(),
      numberColumnExamples: text(),
      currencyColumn: text(),
      currencyColumnDescription: text(),
      currencyColumnExamples: text(),
      percentageColumn: text(),
      percentageColumnDescription: text(),
      percentageColumnExamples: text(),
      dateColumn: text(),
      dateColumnDescription: text(),
      dateColumnExamples: text(),
      greaterThanOperator: text(),
      greaterThanOrEqualToOperator: text(),
      lessThanOperator: text(),
      lessThanOrEqualToOperator: text(),
      equalToOperator: text(),
      notEqualToOperator: text(),
      betweenOperator: text(),
      returnToStart: text(),
      customValue: text(),
      customDate: text(),
      wordIf: text(),
      wordAnd: text(),
      wordThen: text(),
      wordElse: text(),
      preview: text(),
      previewMessage: text(),
      loadingPreview: text(),
      customNumberInputPlaceholder: text(),
      textInputPlaceholder: text(),
      numberInputPlaceholder: text(),
      currencyInputPlaceholder: text(),
      percentageInputPlaceholder: text(),
      wordValue: text(),
      newColumn: text(),
      newColumnName: text(),
      conditionalSuccessToastHeader: text(),
      conditionalSuccessToastMessage: text(),
      conditionalFailureToastHeader: text(),
      conditionalFailureToastMessage: text()
    },
    createColumn: text()
  },
  defaultReportConfiguration: {
    fetchFailedHeader: text(),
    fetchFailedBody: text()
  },
  savedView: {
    allChangesSaved: text(),
    enterViewName: text(),
    viewName: text(),
    viewDescription: text(),
    data: text(),
    presentation: text(),
    analysis: text(),
    modal: {
      createSuccessBody: text(),
      createSuccessHeader: text(),
      createFailedBody: text(),
      createFailedHeader: text(),
      createView: text(),
      deleteDisabledTooltip: text(),
      deleteBody1: text(),
      deleteBody2: text(),
      deleteConfirmationLabel: format<{ deleteConfirm: string }>(),
      deleteHelper: format<{ deleteConfirm: string }>(),
      deleteSuccessHeader: text(),
      deleteFailedBody: text(),
      deleteFailedHeader: text(),
      deleteSavedView: text(),
      deleteSuceededMessage: text(),
      deleteTitle: text(),
      showingByCategorizedBy: {
        by: text(),
        showing: text(),
        categorized: text()
      },
      title: text(),
      titleError: text(),
      titleDuplicate: text(),
      titlePlaceHolder: text(),
      descriptionPlaceholder: text(),
      updateSavedView: text()
    },
    editErrorToast: {
      header: text(),
      body: text()
    },
    controlsErrorToast: {
      header: text(),
      body: text()
    },
    controls: {
      deleteView: text(),
      visualization: text(),
      color: text(),
      verticalBarChart: text(),
      horizontalBarChart: text(),
      lineChart: text(),
      pieChart: text(),
      addTarget: text(),
      editTarget: text()
    },
    targetStatusBadge: {
      target: text(),
      conditions: {
        greaterThan: text(),
        greaterThanOrEqualTo: text(),
        lessThan: text(),
        lessThanOrEqualTo: text(),
        equalTo: text(),
        notEqualTo: text()
      },
      per: text()
    }
  },
  exportModal: {
    cancel: text(),
    currentFilters: text(),
    description: text(),
    filter: text(),
    filterDisabledText: format<{ max: string }>(),
    noFilters: text(),
    send: text(),
    toasts: {
      titleSuccess: text(),
      bodySuccess: text(),
      titleFailure: text(),
      bodyFailure: text()
    },
    title: text()
  },
  colorControlsModal: {
    title: text(),
    description: text()
  },
  setTargetModal: {
    preview: text(),
    addTarget: text(),
    editTarget: text(),
    description: text(),
    conditionDescription: text(),
    secondConditionDescription: text(),
    elseConditionDescription: text(),
    condition: text(),
    value: text(),
    status: text(),
    addStatus: text(),
    removeStatus: text(),
    cancel: text(),
    add: text(),
    save: text(),
    remove: text(),
    onTarget: text(),
    onTrack: text(),
    needsFocus: text(),
    conditions: {
      greaterThan: text(),
      greaterThanOrEqualTo: text(),
      lessThan: text(),
      lessThanOrEqualTo: text(),
      equalTo: text(),
      notEqualTo: text()
    },
    validationErrorMessage: {
      greaterThan: text(),
      lessThan: text()
    },
    failureToast: {
      title: text(),
      description: text()
    }
  },
  shareLink: {
    modalTitle: text(),
    modalDescription: text(),
    snapshotLabel: text(),
    snapshotCopySuccessMessage: text(),
    permalinkLabel: text(),
    permalinkCopySuccessMessage: text(),
    copyLinkButton: text(),
    closeModalButton: text(),
    copyLinkSuccessMessage: text(),
    shareButton: text(),
    shareLinkFailureToastTitle: text(),
    shareLinkFailureToastMessage: text()
  },
  copyReport: {
    modalTitle: text(),
    modalDescription: text(),
    reportName: text(),
    reportDescription: text(),
    options: text(),
    copyViews: text(),
    copyAccess: text(),
    confirmButton: text(),
    closeModalButton: text(),
    duplicating: text()
  },
  standardTemplate: {
    modalTitle: text(),
    modalDescription: text(),
    modalPlaceholder: text(),
    closeModalButton: text(),
    copyToClipboardButton: text(),
    copyTemplateSuccessMessage: text()
  },
  standardTemplatePromptsRoute: {
    noDataHeader: text(),
    noDataDescription: text(),
    progressHeader: text(),
    progressDescription: text()
  },
  editSectionLabelModal: {
    title: text(),
    labelInput: text(),
    labelEmpty: text(),
    labelMaxLength: format<{ maxLength: number }>()
  },
  exportPdfModal: {
    showFilters: text(),
    showNameAndDescription: text(),
    detailTableOverLimit: text(),
    title: text(),
    openModalButton: text(),
    detailTable: text(),
    summaryTable: text(),
    formatting: text(),
    downloadButton: text(),
    exportContentLabel: text(),
    marginsLabel: text(),
    narrowMargins: text(),
    normalMargins: text(),
    pageOrientationLabel: text(),
    landscapeOrientation: text(),
    loadingPreview: text(),
    previewError: text(),
    exportDataLoadError: text(),
    tooMuchDataError: text(),
    pageNumberToggle: text(),
    portraitOrientation: text(),
    previewLabel: text(),
    previewTitle: text(),
    completedLabel: text(),
    previewUpdatingLabel: text(),
    visualization: text(),
    noContentSelected: text(),
    includeTimestamp: text(),
    infoToastTitle: text(),
    infoToastBody: text(),
    successToastTitle: text(),
    successToastBody: text(),
    failureToastTitle: text(),
    failureToastBody: text(),
    additionalCategories: format<{ count: number }>(),
    filteredBy: text(),
    filters: {
      text: {
        contains: text(),
        doesNotContain: text(),
        equal: text(),
        notEqual: text(),
        isBlank: text(),
        isNotBlank: text(),
        beginsWith: text(),
        endsWith: text()
      },
      number: {
        equal: text(),
        greaterThanOrEqual: text(),
        lessThanOrEqual: text()
      },
      date: {
        equal: text(),
        greaterThanOrEqual: text(),
        lessThanOrEqual: text()
      },
      and: text(),
      or: text()
    },
    showGridlines: text(),
    showUnderlines: text(),
    numericalColumnsPerRowLabel: text(),
    columnsPerRowLabel: text(),
    fontSizeLabel: text(),
    fontSizeOptions: {
      extraSmall: text(),
      small: text(),
      normal: text(),
      large: text(),
      extraLarge: text()
    },
    maxColumnWidth: text(),
    exportSettingsTitle: text(),
    layoutLabel: text(),
    fontFamilyLabel: text(),
    fontFamilyOptions: {
      dmSans: text(),
      dmMono: text(),
      arial: text(),
      timesNewRoman: text()
    },
    headerSection: {
      headerTitle: text(),
      showPageSettings: text(),
      showOnAllPageSetting: text(),
      showOnlyOnFirstPageSetting: text(),
      primaryTitle: text(),
      secondaryTitle: text(),
      subtitle: text(),
      numberFormattingTitle: text(),
      numberFormattingThousands: text(),
      continuationLabel: text(),
      currencySymbolLabel: text(),
      currencySymbolOptions: {
        all: text(),
        none: text(),
        firstLastPerGroup: text()
      },
      appliedFilters: text(),
      showLabel: text(),
      appliedLabel: text(),
      filterLabel: text(),
      filtersLabel: text()
    },
    footerSection: {
      footerTitle: text(),
      noteLabel: text(),
      showPageNumberLabel: text(),
      showExportTimestampLabel: text()
    },
    filterSection: {
      filterLabel: text()
    },
    tooltipText: text(),
    setAsDefaultButton: text(),
    setAsDefaultTooltip: text(),
    setAsDefaultSuccessToast: text(),
    setAsDefaultErrorToast: text(),
    tableFormatting: {
      tableFormattingTitle: text(),
      fontSizeLabel: text(),
      columnsPerPageLabel: text(),
      maxColumnWidthLabel: text(),
      showGridlinesLabel: text(),
      showUnderlines: text(),
      keepRowGroupsTogetherOnPageBreaksLabel: text(),
      keepColumnGroupsTogetherOnPageBreaksLabel: text(),
      tooltipMaxColumnWidth: text(),
      fontSizeOptions: {
        small: text(),
        normal: text(),
        large: text(),
        extraLarge: text()
      },
      maxColumnWidthPxLabel: text(),
      infoTooltip: text()
    }
  },
  reportGallery: {
    datasetListHeader: text(),
    linkToReportSettings: text(),
    datasetListCloseButton: text(),
    multipleDataSourceColumnValue: text(),
    searchPlaceholder: text(),
    serverErrorToastTitle: text(),
    serverErrorToastBody: text(),
    clearFiltersTitle: text(),
    noMatchesHeader: text(),
    noMatchesDescription: text(),
    emptyReportsHeader: text(),
    emptyReportsAdminDescription: text(),
    standardReports: text(),
    standardReportsDescription: text(),
    searchFilterLabel: text(),
    createdByFilterLabel: text(),
    visibilityFilterLabel: text(),
    sortOptionLabel: text(),
    viewOptionLabel: text(),
    viewAsGridAriaLabel: text(),
    viewAsListAriaLabel: text(),
    privateVisibility: text(),
    publicVisibility: text(),
    userNotFound: text(),
    adminUser: text(),
    openGovUser: text(),
    datasetUpdated: text(),
    reportUpdated: text()
  },
  multidataset: {
    serverSideDatasource: {
      defaultRowGroupName: text(),
      failure: {
        generic: {
          headerText: text(),
          bodyText: text()
        },
        cyclicCalculation: {
          headerText: text(),
          bodyText: text()
        }
      }
    },
    controls: {
      undo: text()
    },
    data: {
      loading: text(),
      noResults: text(),
      noResultsDescription: text()
    },
    expandCollapse: {
      collapse: text(),
      collapseOneLevel: text(),
      expand: text(),
      expandOneLevel: text(),
      showTotalsAtBottom: text()
    },
    addCalculatedColumnGroupOption: {
      label: text(),
      description: text()
    },
    addCalculatedRowGroupOption: {
      label: text(),
      description: text()
    },
    addColumn: text(),
    addColumnGroup: text(),
    addColumnModalTitle: text(),
    addColumnModalInstructions: text(),
    addColumnOrRow: { add: text(), columnGroup: text(), rowGroup: text() },
    addDataColumnGroupOption: {
      label: text(),
      description: text()
    },
    addOverrideRowGroupOption: {
      label: text(),
      description: text()
    },
    addRowGroup: text(),
    addRowGroupCoAOption: {
      label: text(),
      description: text()
    },
    columns: text(),
    emptyValues: text(),
    calculatedText: text(),
    columnEditorSection: {
      dataUpdatedDate: format<{ date: Date }>(),
      accordionTitleSetup: text(),
      accordionTitleFilter: text(),
      columnHeaderUniqueInvalid: text(),
      addFilterButton: text(),
      clearFiltersButton: text(),
      applyFilterButton: text(),
      aggregateBySum: text(),
      resetColumnOrderTooltip: text(),

      filter: {
        addButton: text(),
        applyButton: text(),
        clearButton: text(),
        dataRangeLabel: text(),
        addCondition: text(),
        filterableInputPlaceHolder: text(),
        noneSelected: text(),
        filterEmptyResultText: text(),
        clearDates: text(),
        placeholderSelectDateField: text(),
        relativeOptions: {
          FiscalYear: text(),
          FiscalQuarter: text(),
          CalendarYear: text(),
          CalendarQuarter: text(),
          Month: text(),
          Custom: text(),
          InceptionToDate: text(),
          InceptionToYear: text(),
          RollingNFiscalYears: text(),
          RollingNCalenderYears: text(),
          RollingNFiscalQuarters: text(),
          RollingNCalendarQuarters: text(),
          CurrentFiscalYear: text(),
          PriorFiscalYear: text(),
          NextFiscalYear: text(),
          CurrentAndPriorFiscalYear: text(),
          NextTwoFiscalYear: text(),
          PriorTwoFiscalYears: text(),
          CurrentAndPriorTwoFiscalYears: text(),
          CurrentCalendarYear: text(),
          PriorCalendarYear: text(),
          NextCalendarYear: text(),
          CurrentFiscalYearToDate: text(),
          CurrentFiscalYearToCurrentMonth: text(),
          CurrentFiscalYearToPriorMonth: text(),
          PriorFiscalYearToDate: text(),
          CurrentFiscalQuarter: text(),
          CurrentFiscalQuarterToDate: text(),
          PriorFiscalQuarter: text(),
          PriorFiscalQuarterToDate: text(),
          NextFiscalQuarter: text(),
          CurrentCalendarYearToDate: text(),
          PriorCalendarYearToDate: text(),
          CurrentCalendarQuarter: text(),
          CurrentCalendarQuarterToDate: text(),
          PriorCalendarQuarter: text(),
          PriorCalendarQuarterToDate: text(),
          NextCalendarQuarter: text(),
          CalendarCalendarMonth: text(),
          CurrentMonth: text(),
          CurrentMonthToDate: text(),
          PriorMonth: text(),
          PriorMonthToDate: text(),
          NextMonth: text(),
          RollingNMonths: text(),
          InceptionToPeriod: text(),
          CurrentFiscalYearToCurrentPeriod: text(),
          CurrentFiscalYearToPriorPeriod: text(),
          PriorFiscalYearToCurrentPeriod: text(),
          CurrentFiscalQuarterToCurrentPeriod: text(),
          PriorFiscalQuarterToCurrentPeriod: text(),
          CurrentCalendarYearToCurrentPeriod: text(),
          PriorCalendarYearToCurrentPeriod: text(),
          CurrentCalendarQuarterToCurrentPeriod: text(),
          PriorCalendarQuarterToCurrentPeriod: text(),
          InceptionToCurrentMonth: text(),
          Period: text(),
          CurrentPeriod: text(),
          PriorPeriod: text(),
          PriorYearCurrentPeriod: text(),
          PriorYearPriorPeriod: text(),
          RollingNPeriods: text()
        }
      },
      backButton: text(),
      columnEditor: text(),
      editColumnGroup: text(),
      editColumn: text(),
      setup: text(),
      filters: text(),
      dataSource: text(),
      dataSourceUnavailable: text(),
      selectPlaceholder: text(),
      defaultHeader: text(),
      customHeader: text(),
      organizeBy: text(),
      failureToastTitle: text(),
      failureToastMessage: text(),
      invalidDateMessage: text(),
      placeholderSelectDateField: text(),
      defaultGroupName: text(),
      asOfLabel: text(),
      asOfInvalid: text(),
      filtersTooltip: {
        dateRangeTitle: text(),
        appliedFilters: format<{
          filtersLength: number;
          pluralCharacter: string;
        }>()
      }
    },
    dataSource: text(),
    duplicateObjectName: text(),
    editCalculatedColumnPanel: {
      header: {
        dropdown: {
          duplicate: {
            label: text()
          },
          delete: {
            label: text()
          }
        },
        dialog: {
          delete: {
            title: text(),
            description: text(),
            cancel: text(),
            confirm: text()
          }
        }
      },
      title: text(),
      typeLabel: text(),
      typeSelect: {
        variance: text()
      },
      instruction: text(),
      operandALabel: text(),
      operandBLabel: text(),
      headerUniqueInvalid: text(),
      headerCharactersInvalid: format<{ invalidString: string }>(),
      calculatedColumnHeaderEmptyInvalid: text(),
      formulaLabel: text(),
      headerLabel: text(),
      displayLabel: text(),
      displaySelect: {
        currency: text(),
        number: text(),
        percent: text()
      },
      applyButton: text()
    },
    editCalculatedRowPanel: {
      header: {
        dropdown: {
          duplicate: {
            label: text()
          },
          delete: {
            label: text()
          }
        },
        dialog: {
          delete: {
            title: text(),
            description: text(),
            cancel: text(),
            confirm: text(),
            isLastOne: text(),
            selectedRowGroupDependantDescription: format<{ selectedRowGroupName: string }>(),
            warning: text()
          }
        }
      },
      title: text(),
      typeLabel: text(),
      typeSelect: {
        variance: text()
      },
      instruction: text(),
      operandALabel: text(),
      operandBLabel: text(),
      headerUniqueInvalid: text(),
      headerCharactersInvalid: format<{ invalidString: string }>(),
      calculatedColumnHeaderEmptyInvalid: text(),
      formulaLabel: text(),
      headerLabel: text(),
      displayLabel: text(),
      displaySelect: {
        currency: text(),
        number: text(),
        percent: text()
      },
      applyButton: text()
    },
    editFormatting: {
      additionalOptions: {
        showDashesForZeros: text(),
        hideThousandsSeparator: text(),
        hideZeroValueRows: text(),
        hideZeroValueColumns: text()
      },
      additionalOptionsLabel: text(),
      apply: text(),
      cancel: text(),
      currencyFormatDescription: text(),
      currencyFormattingOptions: {
        hundreds: text(),
        hundredths: text(),
        ones: text(),
        tens: text(),
        tenths: text(),
        thousands: text()
      },
      currencyLabel: text(),
      currencySignCheckboxLabel: text(),
      editFormatting: text(),
      formatOptionLabels: {
        hundreds: text(),
        hundredths: text(),
        ones: text(),
        tens: text(),
        tenths: text(),
        thousands: text()
      },
      modalTitle: text(),
      negativeNumberFormattingDescription: text(),
      negativeNumberFormatLabel: text(),
      negativeNumberFormattingOptions: {
        accounting: text(),
        standard: text()
      },
      zeroNumbersFormatLabel: text(),
      zeroNumbersFormattingCheckboxes: {
        rows: text()
      },
      hideColumnGroupHeadersLabel: text(),
      hideColumnGroupHeadersCheckboxLabel: text(),
      hideColumnGroupHeadersCheckMessage: text(),
      hideColumnGroupHeadersUnCheckMessage: text(),
      showRootLevelBreakdownsLabel: text(),
      showRootLevelBreakdownsCheckboxLabel: text(),
      numberFormattingDescription: text(),
      numberFormattingOptions: {
        hundreds: text(),
        hundredths: text(),
        ones: text(),
        tens: text(),
        tenths: text(),
        thousands: text()
      },
      numberLabel: text(),
      percentageFormattingDescription: text(),
      percentageFormattingOptions: {
        hundredths: text(),
        ones: text(),
        tenths: text()
      },
      percentageLabel: text(),
      restore: text(),
      roundingControlLabel: text(),
      roundingControlDescription: text(),
      roundingOptions: {
        roundNearestScale4: {
          label: text(),
          description: text()
        },
        roundUp: {
          label: text(),
          description: text()
        },
        roundNearest: {
          label: text(),
          description: text()
        }
      },
      numberDisplayLabel: text(),
      calcIntersectionLabel: text(),
      calcIntersectionDescription: text(),
      calcIntersectionOptions: {
        doNotCalculate: text(),
        columnFormula: text(),
        rowFormula: text()
      }
    },
    editModeTitle: text(),
    editViewDetailsTitle: text(),
    errorStateModal: {
      title: text(),
      description: text(),
      undoButton: text()
    },
    exportStatusToastInfo: {
      toastBody: {
        SUCCESS: text(),
        FAILURE: text(),
        LOADING: text()
      },
      toastTitle: {
        SUCCESS: text(),
        FAILURE: text(),
        LOADING: text()
      }
    },
    lastUpdated: text(),
    manageColumnsDropdown: {
      buttonText: text(),
      onlyShowCalculatedColumns: text(),
      showAll: text(),
      failureToastTitle: text(),
      failureToastBody: text()
    },
    overrideRowEditorSection: {
      title: text(),
      delete: text(),
      rowSectionTitle: text(),
      label: text(),
      show: text(),
      groupBy: text(),
      groupByMoveUp: text(),
      groupByMoveDown: text(),
      groupByDelete: text(),
      groupByAddField: text(),
      groupByButtonSection: text(),
      columnSectionTitle: text(),
      columnSectionDescription: text(),
      applyButton: text(),
      addFilterButton: text(),
      clearFiltersButton: text(),
      columnGroupParentsFilterOverviewWording: [text(), text()],
      columnGroupParentsFilterOverviewNoFilter: text()
    },
    rows: text(),
    rowEditorSection: {
      formAriaLabel: text(),
      rowEditor: text(),
      accordionTitleSetup: text(),
      groupBy: text(),
      accordionTitleFilter: text(),
      groupByMoveUp: text(),
      groupByMoveDown: text(),
      groupByDelete: text(),
      groupByAddField: text(),
      groupByButtonSection: text(),
      groupName: text(),
      show: text(),
      applyButton: text(),
      defaultGroupName: text()
    },
    searchDataSource: text(),
    saveAndReturn: {
      saveAndReturn: text(),
      modalTitle: text(),
      modalBody: text(),
      fyfpFilterDescription: text(),
      modalAreYouSure: text(),
      cancel: text(),
      save: text(),
      successToastTitle: text(),
      successToastBody: text(),
      failureToastTitle: text(),
      failureToastBody: text(),
      saveAndExit: text()
    },
    saveAsNewViewTitle: text(),
    selectAColumnOrRowGroup: text(),
    unsavedChangesModal: {
      title: text(),
      body: text(),
      cancelButton: text(),
      confirmButton: text()
    },
    updateDetailsViewToastInfo: {
      toastBody: {
        success: text(),
        failure: text()
      },
      toastTitle: {
        success: text(),
        failure: text()
      }
    },
    updateView: {
      button: text(),
      modal: {
        title: text(),
        alternative: text(),
        cancel: text(),
        confirmation: text(),
        description: text()
      },
      successToast: {
        title: text(),
        body: text()
      },
      errorToast: {
        title: text(),
        body: text()
      }
    },
    viewEditorSection: {
      header: text(),
      headerDescription: text(),
      fyfpFilterDescription: text()
    },
    zeroRows: {
      noData: text(),
      editor: text(),
      editorLink: text(),
      viewer: text()
    }
  },
  routeErrorElement: {
    pageDoesNotExist: text(),
    somethingWentWrong: text(),
    tryRefreshingPage: text(),
    or: text(),
    contactSupport: text(),
    ifErrorPersists: text()
  }
};

export const reportLocaleText = processNamespace({ report }).report;

export { currentLocale } from './currentLocale';
